<template>
  <section>
    <div class="bubbles pattern curve">
      <div class="bubble"></div>
      <div class="bubble"></div>
      <div class="bubble"></div>
      <div class="bubble"></div>
      <div class="bubble"></div>
      <div class="bubble"></div>
      <div class="bubble"></div>
      <div class="bubble"></div>
      <div class="bubble"></div>
      <div class="bubble"></div>
      <v-row>
        <v-col cols="12" md="6">
          <v-card-text>
            <div style="text-align: center">
              <h2 style="margin-top: 150px">Download Now</h2>
              <h1 style="margin-top: 10px">
                <img style="width: 30px; margin-right: 5px" src="../assets/driverappLogo.webp" />Senz-i SmartDriver App
              </h1>
              <h5><i>Sigsenz Technologies Pvt Ltd</i></h5>
              <p>
                <i>This app helps fleet drivers to operate their vehicles
                  through smart decisions and follow processes to ensure safety
                  compliances, optimise and maximise vehicle utilisation through
                  smart route planning.</i>
              </p>
              <v-row>
                <v-col cols="12">
                  <img style="width: 100px; text-align: center; margin-top: 20px" src="../assets/app-qr-code.png" />
                </v-col>
                <v-col cols="12">
                  <v-btn style="margin-top: 30px" link color="#1e1e1e" dark
                    href="https://play.google.com/store/apps/details?id=com.sigsenz.senzismartdriver" target="_blank">
                    <v-icon left>mdi-google-play </v-icon>Get it on Google Play
                  </v-btn>
                  <h4 style="margin-top: 10px">Version : 1.0.7</h4>
                  <p style="margin-top: 10px">
                    Last Updated On : Feb 18, 2023
                  </p>
                </v-col>
              </v-row>
            </div>
          </v-card-text>
        </v-col>
        <v-col cols="12" md="6">
          <div class="card-holder">
            <v-card elevation="1" class="card">
              <v-card-text>
                <v-row>
                  <v-col sm="12" cols="12" class="text-center">
                    <div>
                      <img class="logo" src="../assets/login-page-logo.png" style="width:300px; border-radius: 5px;
   
    " />
                    </div>
                    <h3 class="sigin-title">LMS</h3>
                    <p style="font-size: 10px; text-align: center">
                      version: 1.26.2
                    </p>
                    <h3 class="sigin-title">Sign In</h3>

                    <v-spacer style="height: 10px"></v-spacer>
                    <v-alert color="error" v-if="errorText" text dense>{{
                      errorText
                    }}</v-alert>
                    <v-text-field type="email" v-model="username" outlined dense prepend-inner-icon="mdi-account-circle"
                      placeholder="Enter Username" label="Username" v-on:keyup.enter="login"></v-text-field>
                    <PasswordComponent type="password" :dense="false" v-model="password" label="Password"
                      @onEnter="login"></PasswordComponent>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col md="12" cols="12" class="si">
                    <v-btn class="button-login" type="submit" style="width: 100%" dark right @click="login()">Sign
                      In</v-btn>
                  </v-col>

                  <v-col sm="12" style="text-align: left">
                    <!-- <label>
              <a href="#" class="card-link fp">Forgot Password?</a>
            </label> -->
                  </v-col>
                </v-row>
                <v-list-item-content>
                  <h6 style="color: black">Powered By</h6>

                  <div style="padding: 2px 20px">
                    <a href="https://sigsenz.com/">
                      <img style="width: 100px" src="../assets/sig-logo.png" alt="SigSenz" />
                    </a>
                  </div>
                </v-list-item-content>
              </v-card-text>
            </v-card>
          </div>
        </v-col>
      </v-row>
    </div>
  </section>
</template>

<script>
import PasswordComponent from "@/components/PasswordComponent.vue";
import axios from "axios";
export default {
  name: "Login-Page",
  components: {
    PasswordComponent,
  },
  computed: {
    user() {
      return this.$store.state.user.user;
    },
    version() {
      return process.env.PACKAGE_VERSION;
    },
    groups() {
      return this.$store.state.user.user.groupName;
    },
  },
  data() {
    return {
      username: "",
      password: "",
      errorText: "",
    };
  },
  mounted() {
    //this.getAppDetails();
    if (this.user.isLoggedin) {
      this.$router.push("/home");
    }
  },
  methods: {
    async getAppDetails() {
      const packageId = "com.sigsenz.smartdriver";
      const endpoint = `https://play.google.com/store/apps/details?id=${packageId}&hl=en`;

      axios
        .get(endpoint, {
          headers: {
            "User-Agent":
              "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36",
          },
        })
        .then((response) => {
          const regex = /window\.__INITIAL_STATE__ = ([^;]+);/; // Regex to extract the JSON data
          const match = regex.exec(response.data);
          const jsonString = match && match[1];
          const appData = JSON.parse(jsonString);
          console.log(appData); // Logs the app data in JSON format
        })
        .catch((error) => {
          console.error(error);
        });
    },
    async login() {
      this.errorText = "";
      if (this.username == "" || this.username == null) {
        this.errorText = "Username can't be empty";
        return;
      }
      if (this.password == "" || this.password == null) {
        this.errorText = "Password can't be empty";
        return;
      }
      await this.$store.dispatch("login", [this.username, this.password]);
      this.errorText = this.$store.state.user.user.message;
      if (this.user.isLoggedin) {
        this.$userHub.start();
        this.groups.forEach((element) => {
          this.$userHub.invoke("JoinGroup", element);
        });
        if (this.$store.state.user.user.userType != "TS") {
          if (this.$route.path == "/login") {
            this.$router.push("/home");
          }
        } else {
          this.$router.push("/transporters");
        }
      }
    },
  },
};
</script>

<style scoped>
.text-white {
  color: white;
}

.whitebackground {
  background: white !important;
}

.text-center {
  text-align: center;
}

.card-holder {
  /* other base styles go here */
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.button-login {
  background-color: #f3652c !important;
  border-color: #1e1e1e !important;
}

.card {
  padding: 20px 20px 0px 20px;
  text-align: center;
  position: absolute;
}

@media only screen and (max-width: 600px) {
  .button-login {
    width: 100% !important;
  }

  .curve {
    position: relative !important;
  }
}

.bubbles {
  width: 100%;
  height: 100%;
  z-index: 0;
  overflow: hidden;
  top: 0;
  left: 0;
  background-color: #fff;
  background-image: linear-gradient(315deg, #f78f6c 30%, #fff 100%);
}

.bubble {
  position: absolute;
  bottom: -100px;
  width: 40px;
  height: 40px;
  background: #f1f1f1;
  border-radius: 50%;
  opacity: 0.5;
  animation: rise 10s infinite ease-in;
}

.bubble:nth-child(1) {
  width: 40px;
  height: 40px;
  left: 10%;
  animation-duration: 8s;
}

.bubble:nth-child(2) {
  width: 20px;
  height: 20px;
  left: 20%;
  animation-duration: 5s;
  animation-delay: 1s;
}

.bubble:nth-child(3) {
  width: 50px;
  height: 50px;
  left: 35%;
  animation-duration: 7s;
  animation-delay: 2s;
}

.bubble:nth-child(4) {
  width: 80px;
  height: 80px;
  left: 50%;
  animation-duration: 11s;
  animation-delay: 0s;
}

.bubble:nth-child(5) {
  width: 35px;
  height: 35px;
  left: 55%;
  animation-duration: 6s;
  animation-delay: 1s;
}

.bubble:nth-child(6) {
  width: 45px;
  height: 45px;
  left: 65%;
  animation-duration: 8s;
  animation-delay: 3s;
}

.bubble:nth-child(7) {
  width: 90px;
  height: 90px;
  left: 70%;
  animation-duration: 12s;
  animation-delay: 2s;
}

.bubble:nth-child(8) {
  width: 25px;
  height: 25px;
  left: 80%;
  animation-duration: 6s;
  animation-delay: 2s;
}

.bubble:nth-child(9) {
  width: 15px;
  height: 15px;
  left: 70%;
  animation-duration: 5s;
  animation-delay: 1s;
}

.bubble:nth-child(10) {
  width: 90px;
  height: 90px;
  left: 25%;
  animation-duration: 10s;
  animation-delay: 4s;
}

@keyframes rise {
  0% {
    bottom: -100px;
    transform: translateX(0);
  }

  50% {
    transform: translate(100px);
  }

  100% {
    bottom: 1080px;
    transform: translateX(-200px);
  }
}

.curve {
  width: 100%;
  bottom: 0;
  text-align: center;
  position: absolute;
}

.curve::before {
  content: "";
  display: block;
  position: absolute;
  border-radius: 100% 50%;
  width: 80%;
  height: 86%;
  -webkit-transform: translate(85%, 60%);
  transform: translate(85%, 60%);
  background-color: #1e1e1e;
}

.curve2 {
  width: 100%;
  bottom: 0;
  text-align: center;
}

.curve2::before {
  content: "";
  display: block;

  border-radius: 100% 50%;
  width: 80%;
  height: 86%;
  -webkit-transform: translate(85%, 60%);
  transform: translate(85%, 60%);
  background-color: #1e1e1e;
}
</style>
